import type { LastDistributionValuesResponseProps } from '../../../context/types'

export const setInitialValues = (data: LastDistributionValuesResponseProps) => {
  return {
    invoiceDays: String(data.previousMonthBillingDays || ''),
    weekdays: String(data.weekdayPercentage || '100'),
    saturday: String(data.saturdayPercentage || ''),
    sunday: String(data.sundayHolidayPercentage || ''),
    holidays: !!data.holidays.length ? data.holidays.map((holiday) => ({ date: holiday })) : []
  }
}
